import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { AppProvider } from "./context/AppContext";
import {
  PublicOnly,
  RequireAdmin,
  RequireAuth,
  RequireSuperAdmin,
  SuperAdminGate,
} from "./components/RouteGuards";
import EnvBanner from "./components/EnvBanner";
import Layout from "./components/Layout";
import EmptyState from "./components/EmptyState";
import AuthPage from "./pages/AuthPage";
import {
  CheckEmail,
  ForgotPassword,
  GmailSecurity,
  ResetPassword,
  SecureAccount,
  VerifyEmail,
} from "./pages/AccountPages";
import Dashboard from "./pages/Dashboard";
import FindJobs from "./pages/FindJobs";
import Tracker from "./pages/Tracker";
import JobDetail from "./pages/JobDetail";
import Contacts from "./pages/Contacts";
import Documents from "./pages/Documents";
import Profile from "./pages/Profile";
import Memory from "./pages/Memory";
import ConnectExtension from "./pages/ConnectExtension";
import Platypus from "./pages/Platypus";
import Admin from "./pages/Admin";
import SuperAdmin from "./pages/SuperAdmin";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Landing from "./pages/Landing";

function NotFound() {
  return (
    <div className="card mt-4">
      <EmptyState
        icon="bi-signpost-split"
        title="Page not found"
        action={
          <Link to="/" className="btn btn-primary btn-sm">
            Go home
          </Link>
        }
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <EnvBanner />
      <AuthProvider>
        <Routes>
          <Route
            path="login"
            element={
              <PublicOnly>
                <AuthPage mode="login" />
              </PublicOnly>
            }
          />
          <Route
            path="register"
            element={
              <PublicOnly>
                <AuthPage mode="register" />
              </PublicOnly>
            }
          />
          <Route
            path="check-email"
            element={
              <PublicOnly>
                <CheckEmail />
              </PublicOnly>
            }
          />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="verify-email" element={<VerifyEmail />} />
          <Route path="gmail-security" element={<GmailSecurity />} />
          <Route path="secure-account" element={<SecureAccount />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="welcome" element={<Landing />} />
          <Route
            element={
              <RequireAuth>
                <SuperAdminGate>
                  <AppProvider>
                    <Layout />
                  </AppProvider>
                </SuperAdminGate>
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="find" element={<FindJobs />} />
            <Route path="platypus" element={<Platypus />} />
            {/* Back-compat: the agent was formerly called the Automator. */}
            <Route path="automator" element={<Navigate to="/platypus" replace />} />
            <Route path="tracker" element={<Tracker />} />
            <Route path="jobs/:id" element={<JobDetail />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="documents" element={<Documents />} />
            <Route path="profile" element={<Profile />} />
            <Route path="memory" element={<Memory />} />
            <Route path="connect-extension" element={<ConnectExtension />} />
            <Route
              path="admin"
              element={
                <RequireAdmin>
                  <Admin />
                </RequireAdmin>
              }
            />
            <Route
              path="superadmin"
              element={
                <RequireSuperAdmin>
                  <SuperAdmin />
                </RequireSuperAdmin>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
